module.exports = __webpack_public_path__ + "img/fondo_test_2.325f6069.svg";